import angular from "../../../_snowpack/pkg/angular.js";
import {Configs, Language, Translations} from "../../../_snowpack/link/dist/@salaxy/core/salaxy-lib-core.js";
import {AppInsightExceptionTracking, SalaxyNg1ComponentsModule, SitemapHelper, TemplateInterceptor, UsecasesCrudController, AccountingTargetCrudController, PaymentChannelController, ServiceModelCrudController} from "../../../_snowpack/link/dist/@salaxy/ng1/salaxy-lib-ng1.js";
import {ProAccounts, ProAccountSelector, ProCustomerQuery, ProListNavi, ProListSidebar, ProLogin, ProPanel, ProWorkflowBadge} from "../../components/pro/index.js";
import {
  AccountingReportProController,
  CalculationsNaviProController,
  CustomerDataController,
  InvoiceProController,
  ProController,
  HouseholdYearProController,
  WorkflowBadgeProController
} from "../../controllers/pro/index.js";
import {ProFilters} from "../../filters/pro/index.js";
import {PartnerSettings, ProService} from "../../services/pro/index.js";
import {RouteConfigPro} from "./route-config-pro.js";
import {sitemap} from "./sitemap.js";
import {OnAuthenticatedSession} from "./on-authenticated-session.js";
import proSiteMapFi from "../../../i18n/locales/fi/PRO_Sitemap.json.proxy.js";
import proFi from "../../../i18n/locales/fi/PRO.json.proxy.js";
import proPagesFi from "../../../i18n/locales/fi/PRO_Pages.json.proxy.js";
import proSiteMapEn from "../../../i18n/locales/en/PRO_Sitemap.json.proxy.js";
import proEn from "../../../i18n/locales/en/PRO.json.proxy.js";
import proPagesEn from "../../../i18n/locales/en/PRO_Pages.json.proxy.js";
import proSiteMapSv from "../../../i18n/locales/sv/PRO_Sitemap.json.proxy.js";
import proSv from "../../../i18n/locales/sv/PRO.json.proxy.js";
import proPagesSv from "../../../i18n/locales/sv/PRO_Pages.json.proxy.js";
Configs.current = {...Configs.current, ...{applicationId: "PRO"}};
UsecasesCrudController.prototype.listUrl = "/pro/usecases";
UsecasesCrudController.prototype.detailsUrl = "/pro/usecases/details/";
PaymentChannelController.prototype.listUrl = "/pro/payment-channel";
PaymentChannelController.prototype.detailsUrl = "/pro/payment-channel/details/";
AccountingTargetCrudController.prototype.listUrl = "/pro/accounting-targets";
AccountingTargetCrudController.prototype.detailsUrl = "/pro/accounting-targets/details/";
ServiceModelCrudController.prototype.listUrl = "/pro/service-models";
ServiceModelCrudController.prototype.detailsUrl = "/pro/service-models/details/";
export const module = angular.module("salaxyApp", ["ngRoute", "salaxy.ng1.components.all"]).constant("SITEMAP", sitemap).config([() => {
  console.debug(`App module registering: ${SalaxyNg1ComponentsModule?.name}`);
}]).config(RouteConfigPro).config(["SITEMAP", function(sitemap2) {
  const standard = SitemapHelper.getAllRolesSiteMap();
  standard.push({
    id: "taxcards",
    url: "#/taxcards",
    visibility: "hidden",
    children: [
      {
        title: "SALAXY.PRO_Sitemap.calcDraft.taxCards.main",
        url: "#/taxcards/details/*",
        visibility: "hidden",
        id: "details"
      }
    ]
  });
  standard[0].url = "#/home";
  sitemap2.find((x) => x.id === "customer").children.push(...standard);
  const reports = standard.find((x) => x.id === "reports");
  reports.children.find((x) => x.id === "irpsr").roles = "pro";
  reports.children.find((x) => x.id === "irpsr").isFullWidth = true;
  reports.children.find((x) => x.id === "irepr").roles = "pro";
  reports.children.find((x) => x.id === "irepr").isFullWidth = true;
  SitemapHelper.getSection(standard, "home").visibility = "hidden";
}]).config(AppInsightExceptionTracking).config(["$httpProvider", ($httpProvider) => {
  $httpProvider.interceptors.push(TemplateInterceptor.factory(/views\//, "YYYYMMDDHH"));
}]).run(["UiHelpers", "SessionService", (uiHelpers, sessionService) => {
  if (!sessionService.clientRoles.find((x) => x === "pro")) {
    sessionService.clientRoles.push("pro");
  }
}]).run(OnAuthenticatedSession).run([() => {
  Translations.setLanguage(Language.Fi);
  Translations.addDictionary(Language.Fi, proSiteMapFi);
  Translations.addDictionary(Language.Fi, proFi);
  Translations.addDictionary(Language.Fi, proPagesFi);
  Translations.addDictionary(Language.En, proSiteMapEn);
  Translations.addDictionary(Language.En, proEn);
  Translations.addDictionary(Language.En, proPagesEn);
  Translations.addDictionary(Language.Sv, proSiteMapSv);
  Translations.addDictionary(Language.Sv, proSv);
  Translations.addDictionary(Language.Sv, proPagesSv);
}]).run(["$location", "$rootScope", ($location, $rootScope) => {
  $rootScope.$on("$locationChangeSuccess", () => {
    const launcher = document.querySelector("iframe#launcher");
    if (launcher) {
      if ($location.path().startsWith("/payroll")) {
        launcher.style.display = "none";
      } else {
        launcher.style.display = "";
      }
    }
  });
}]).service("ProService", ProService).service("PartnerSettings", PartnerSettings).controller("AccountingReportProController", AccountingReportProController).controller("CalculationsNaviProController", CalculationsNaviProController).controller("CustomerDataController", CustomerDataController).controller("InvoiceProController", InvoiceProController).controller("ProController", ProController).controller("HouseholdYearProController", HouseholdYearProController).controller("WorkflowBadgeProController", WorkflowBadgeProController).component("salaxyProListNavi", new ProListNavi()).component("salaxyProListSidebar", new ProListSidebar()).component("salaxyProPanel", new ProPanel()).component("salaxyProAccounts", new ProAccounts()).component("salaxyProLogin", new ProLogin()).component("salaxyProAccountSelector", new ProAccountSelector()).component("salaxyProCustomerQuery", new ProCustomerQuery()).component("salaxyProWorkflowBadge", new ProWorkflowBadge()).filter({proStatus: ProFilters.proStatus});
